module.exports = __webpack_public_path__ + "img/adhka-yx1zn.015.ea77f896.jpeg";